import React from 'react'

const Manual_herramienta_arreglo_sku = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Herramienta para arreglo de SKU
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Usa esta herramienta para corregir o ajustar los SKUs de tus productos de forma eficiente dentro del panel de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Herramienta_para_arreglo_de_SKU__6ggLFg1nS5y06Eca2F-n5Q?as=scrollable"
          className="scribe-iframe-general-132"
          width="100%"
          height="5150"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_herramienta_arreglo_sku
